/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AiModelPricingListModel } from '../../models/ai-model-pricing-list-model';

export interface GetModelPricing$Params {
}

export function GetModelPricing(http: HttpClient, rootUrl: string, params?: GetModelPricing$Params, context?: HttpContext): Observable<StrictHttpResponse<AiModelPricingListModel>> {
  const rb = new RequestBuilder(rootUrl, GetModelPricing.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AiModelPricingListModel>;
    })
  );
}

GetModelPricing.PATH = '/api/AIUsage/GetModelPricing';
